import React from "react";
import { Typography, Grid, Divider } from "@material-ui/core";
import ReactPlayer from "react-player";

export default props => (
  <div>
    {/* <Typography align="center" variant="h5" component="h1" gutterBottom>
      Automated Book Digitization
    </Typography> */}
    <Typography variant="h5" color="primary" component="h2">
      Schematic
    </Typography>
    <div style={{ textAlign: "center" }}>
      <img
        style={{ borderRadius: "8px", border: "1px solid gray" }}
        src="./Schematic3.jpg"
        alt="Schematic"
        width="50%"
      />
    </div>
    <Divider />
    <br />
    <Typography variant="h5" color="primary" component="h2">
      What does it do?
    </Typography>
    <p>
      As the name suggests, the objective is to create a digital doument of a
      physical book. There is a Mechanical Mechanism which turns pages and
      signals camera app in Android Phone to take a picture. The Picture is
      uploaded to cloud for batch processing of images. Then all the images are
      compiled to a single PDF document, which can be uploaded to WikiBooks.
    </p>
    <Divider />
    <br />
    <Typography variant="h5" color="primary" component="h2">
      Who's done what beforehand?
    </Typography>
    <br />
    <Grid container alignItems="center" spacing={16}>
      <Grid item xs>
        <div align="center" className="player-wrapper">
          <ReactPlayer
            url="https://www.youtube.com/watch?v=L65hRsMsbDI"
            width="100%"
            height="100%"
            controls
          />
        </div>
      </Grid>
      <Grid item xs>
        <div align="center" className="player-wrapper">
          <ReactPlayer
            width="100%"
            height="100%"
            url="https://www.youtube.com/watch?v=OLDeof-67D0"
            controls
          />
        </div>
      </Grid>
      <Grid item xs>
        <div align="center" className="player-wrapper">
          <ReactPlayer
            width="100%"
            height="100%"
            url="https://www.youtube.com/watch?v=T5i_TVgKEAU"
            controls
          />
        </div>
      </Grid>
    </Grid>
    <br />
    <Divider />
    <br />
    <Typography variant="h5" color="primary" component="h2">
      Who will use it ?
    </Typography>
    <p>
      My motivation for making this machine is to be able to make digital copies
      of books for use in WikiBooks.
    </p>
  </div>
);
